export function setPreloader(state, preloader) {
    state.preloader = preloader;
}

/**
 * Establecer un valor para la variable data.
 */
export function resetData(state) {
    state.data = [];
}
export function setFile(state,file) {
    state.params.file = file;
    state.params.validated = false;
}

export function setValidationdata(state, result){
    state.params.validated = result.success

}
export function reset_state(state){
        state.params= {
             file: null,
             validated: false,
    }
}



// WEBPACK FOOTER //
// ./src/modules/import-payment-methods-document/mutations.js